export const FBLabelPosition = {
  ABOVE: "above",
  SIDE: "side",
};